// src/app.component.tsx
import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AnimatePresence } from 'framer-motion';
import { PixelLoader } from './components/ui';
import { publicRoutes } from './routing/public.routes';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <AnimatePresence mode="wait">
        <Suspense fallback={<PixelLoader />}>
          <Routes>
            {publicRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Routes>
        </Suspense>
      </AnimatePresence>
    </HelmetProvider>
  );
};

export default App;